import React, { Component } from 'react';
import i18n from 'app/common/i18n';

@i18n
class DrawerBranding extends Component {
  render() {
    if (__CLIENT__) {
      if (/akutbolig/.test(window.location.hostname)) {
        return (
          <div>
            <div
              style={{
                margin: '1em',
                padding: '0.4em 0.6em',
                background: '#f5f5f5',
                border: '1px solid #ccc'
              }}
            >
              <strong>{this.props.i18n('Need help?')}</strong>
              <br />
              {this.props.i18n('Let us know if you have any questions.')}
              <br />
              {/* <br />
              {this.props.i18n('Call us')}{' '}
              <a href="tel:+4577343033">+45 77 34 30 33</a>
              <br />
              {this.props.i18n('Mon - Thu: 8:00 to 16:00')}
              <br />
              {this.props.i18n('Fri: 8:00 to 15:00')}
              <br />
              <br /> */}
              <br />
              {this.props.i18n('Write an email to')}
              <br />
              <a href="mailto:udlejning@akutbolig.dk">udlejning@akutbolig.dk</a>
            </div>

            <div style={{ margin: '1em 1em 0' }}>
              <a
                href="https://www.akutbolig.dk"
                target="_blank"
                style={{
                  display: 'block',
                  lineHeight: 0,
                  backgroundImage: 'url(/images/akutbolig-logo.png)',
                  height: 160,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat'
                }}
              />
            </div>
          </div>
        );
      }
    }

    return <div />;
  }
}

export default DrawerBranding;
